import YotpoReviews from "../Yotpo/YotpoReviews";
import Product from "../../Types/Product";

const ProductPageReviewsTab = ({
   product,
}: {
    product: Product;
}) => {
    return (
        <div className="w-1/2 md-down:w-full">
            <YotpoReviews
                product={product}
            />
        </div>
    );
};

export default ProductPageReviewsTab;
